<div class="container">
  <div
    class="tabAdmin d-flex flex-row align-items-center justify-content-center"
  >
    <div *inproviderPermmission="['flows.menu.perfil.usuarios','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 1">
      <a href="/admin/"> Home </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.usuarios','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 2">
      <a href="/admin/user"> Usuario </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.clients','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 3">
      <a href="/admin/client"> Contrapartes </a>
    </div>
    <div *inproviderPermmission="myCompaniesPermissions" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 12">
      <a href="/admin/my-companies"> Mis Compañías </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.perfiles','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 4">
      <a href="/admin/profile"> Perfil </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.areas','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 5">
      <a href="/admin/area"> Área </a>
    </div>
    <ng-container *inproviderPermmission="['flows.menu.perfil.areas','flows.admin']">
      <div *ngIf="legalStudyEnabled" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 13">
        <a href="/admin/legal-studies"> Estudios jurídicos </a>
      </div>
    </ng-container>
    <div *inproviderPermmission="['flows.menu.perfil.reporteflows','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 6">
      <div (click)="modalOpenUserManage(report)"><a>Reporte</a></div>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.clausulas','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 7">
      <a href="/admin/clause"> Cláusulas </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.customfields','flows.menu.perfil.counterparty-customfields','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 8">
      <a href="/admin/customfields"> Campos </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.configuracionpjud','flows.menu.perfil.pjudkeys','flows.menu.perfil.gestionruts','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2 mr-4" [class.act]="selecto === 9">
      <a href="/admin/configuracion-pjud"> Configuración PJUD </a>
    </div>
    <div *inproviderPermmission="['flows.menu.perfil.apikeys','flows.admin']" class="bx-cnt pl-2 pb-1 pr-2" [class.act]="selecto === 10">
      <a href="/admin/apikeys"> API Keys </a>
    </div>
    <div *ngIf="whatsappEnabled" class="bx-cnt pl-2 pb-1 pr-2 ml-4" [class.act]="selecto === 11">
      <a href="/admin/whatsapp"> WhatsApp </a>
    </div>
  </div>
  <ng-template #report let-modal>
    <div class="modalBase w-100">
      <span class="btn_Close" (click)="modal.dismiss('Cross click')"
        ><i class="fas fa-times-circle"></i
      ></span>
      <app-admin-report-modal></app-admin-report-modal>
    </div>
  </ng-template>
</div>
